export const PASS_UPPER_LOWER_REGEX = /(?=.*[a-z])(?=.*[A-Z])/;
export const PASS_NUM_SPECIAL_REGEX =
  /(?=.*\d)(?=.*[@$!%*?&#+\- "'(|),./:;<=>\\\][^_`{}~])/;
